import React, { useEffect, useState } from 'react';
import classes from 'src/components/CustomisationPage/pages/Pages.scss';
import { RadioGroup } from 'src/core/forms';
import { Fields, ProductLocation } from 'src/components/CustomisationPage/feature/customisation.types';
import { Field } from 'src/components/Forms/Field';
import { Radio } from 'src/core/forms';
import { distinctUntilKeyChanged, tap } from 'rxjs';
import { ARTWORK_EXISTING } from 'src/components/Artwork/artwork.types';
import { NEW_ARTWORK_ID } from 'src/constants/artwork';
import { useArtwork } from 'src/hooks/useArtwork';
import { LOCATIONS_ARTWORK_ID, NO_CUSTOMISATION_ARTWORK_ID } from 'src/constants/artwork';

import { Button } from '../Button/Button';

import { ArtworkType } from './ArtworkSelect';
import { ArtworkGridWrapper } from './ArtworkSelect';

type Props = {
    locations?: ProductLocation[];
    fieldIndex?: number;
};

export const BundleArtworkSelect: React.FC<Props> = ({ fieldIndex, locations }) => {
    const [hide, setHide] = useState(true);
    const { deduplicatedCustomisations, artworkGrid, applicationMethod, processed, getValueStream, api } =
        useArtwork(fieldIndex);

    useEffect(() => {
        const sub = getValueStream()
            .pipe(
                distinctUntilKeyChanged(`${fieldIndex}.${'artwork'}`),
                tap((values) => {
                    if (
                        values[`${fieldIndex}.${'artwork'}`] &&
                        values[`${fieldIndex}.${'artwork'}`] !== NEW_ARTWORK_ID &&
                        values[`${fieldIndex}.${'artwork'}`] !== 'none'
                    ) {
                        const match = deduplicatedCustomisations.find(
                            (c) =>
                                String(c.artwork_id) === values[`${fieldIndex}.${'artwork'}`] ||
                                String(c.id) === values[`${fieldIndex}.${'artwork'}`],
                        );
                        if (match) {
                            api.setValue(`${fieldIndex}.${ARTWORK_EXISTING}`, JSON.stringify(match));
                        }
                    } else {
                        api.setValue(`${fieldIndex}.${ARTWORK_EXISTING}`, '');
                    }
                }),
            )
            .subscribe();
        return () => sub.unsubscribe();
    }, [api, getValueStream, deduplicatedCustomisations, fieldIndex]);

    return (
        <fieldset>
            <div className={classes.wrapperInfo}>
                {deduplicatedCustomisations?.length > 0 && (
                    <p className={classes.subHeader}>
                        <strong>Choose</strong> from your existing artwork
                    </p>
                )}
                {deduplicatedCustomisations?.length > 6 && (
                    <Button
                        onClick={() => {
                            setHide(hide ? false : true);
                        }}
                        className={classes.radioGridMore}
                        variant="light"
                    >
                        {hide ? '+ Show all existing artwork' : '- Hide existing artwork'}
                    </Button>
                )}
            </div>
            <RadioGroup
                field={fieldIndex ? `${fieldIndex}.${Fields.artwork}` : Fields.artwork}
                initialValue={NEW_ARTWORK_ID}
            >
                <ArtworkGridWrapper
                    description="Add a new customisation"
                    locations={locations}
                    fieldIndex={fieldIndex}
                    artworkGrid={artworkGrid}
                    hide={hide}
                    applicationMethod={applicationMethod}
                    processed={processed}
                    type={ArtworkType.Bundle}
                />
                {fieldIndex === LOCATIONS_ARTWORK_ID && (
                    <div className={classes.noCustomisation}>
                        <Field>
                            <Radio id={`${fieldIndex}no-customisation`} value={NO_CUSTOMISATION_ARTWORK_ID} />
                            <label htmlFor={`${fieldIndex}no-customisation`}>or choose to have no customisation</label>
                        </Field>
                    </div>
                )}
            </RadioGroup>
        </fieldset>
    );
};
